module.exports = __webpack_public_path__ + "img/triton.0dc78c97.png";